import { useQuery } from '@tanstack/react-query';
import { publicApi } from '@/services/api';

export interface PlatformBranding {
    platform_name: string;
    logo_url: string | null;
    favicon_url: string | null;
    seo_title: string | null;
    seo_description: string | null;
    seo_keywords: string | null;
}

/** Public, unauthenticated — feeds the marketing site's header/footer logo+name and the browser-tab favicon, before any login exists. */
export function usePlatformBranding() {
    return useQuery({
        queryKey: ['public', 'platform-branding'],
        queryFn: async () => {
            const { data } = await publicApi.get<{ success: boolean; data: PlatformBranding }>('/platform/branding');
            return data.data;
        },
        staleTime: 5 * 60 * 1000,
    });
}
